import React from 'react';
import { Link } from 'gatsby';

import { Button } from '../../../../../packages/ui-components/shadcn/Button';

interface CtaNavProps {
  blobNavActive: boolean;
  nonTransactionalCTA: {
    linkType?: string;
    internalLink?: { slug: { current: string }; title: string };
    href?: string;
    caption?: string;
  };
}

const CtaNav: React.FC<CtaNavProps> = ({
  blobNavActive,
  nonTransactionalCTA,
}) => (
  <div
    className={`fixed ${
      blobNavActive ? 'bottom-0 opacity-100' : '-bottom-20 opacity-25'
    } transition-all duration-300 ease-in-out w-full z-10`}
  >
    <div className="p-4 flex flex-col justify-center items-center bg-background border-t shadow-top-lg lg:hidden">
      <Button asChild className="lg:hidden">
        <Link
          to={
            nonTransactionalCTA?.linkType === 'internal'
              ? `/${nonTransactionalCTA?.internalLink?.slug?.current}`
              : nonTransactionalCTA?.href
          }
          className="text-cta-foreground no-underline"
        >
          {nonTransactionalCTA?.caption ||
            nonTransactionalCTA?.internalLink.title}
        </Link>
      </Button>
    </div>
  </div>
);

export default CtaNav;
